import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { ChannelsService } from '@core/services/channels.service';
import { CommissionsService } from '@core/services/commissions.service';
import { GeneralsService } from '@core/services/generals.service';
import { CommissionsEditComponent } from '@modules/commissions/commissions-edit/commissions-edit.component';
import { Constants } from '@shared/class/constants.class';
import { Commission } from '@shared/interfaces/commission';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-commissions-list',
  templateUrl: './commissions-list.component.html'
})
export class CommissionsListComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public location = 'commissions';
  public dataSource: MatTableDataSource<Commission>;
  public selection = new SelectionModel<Commission>(true, []);
  public commissionsList: Array<Commission> = [];
  public commission: Commission;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filterInput: ElementRef;

  constructor(
    public appConfig: AppConfig,
    public generalsService: GeneralsService,
    public commissionsService: CommissionsService,
    public channelsService: ChannelsService
  ) {
    this.constants.displayedColumns = [
      this.appConfig.ACTIONS.delete.id,
      'id',
      'channel',
      'idChannel',
      'startValue',
      'endValue',
      'fixValue',
      'variableValue',
      this.appConfig.ACTIONS.edit.id
    ];
  }

  ngOnInit() {
    this.generalsService.action$
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe((result: any) => {
        if (result) {
          const actions = this.generalsService.getActions(
            this.constants.displayedColumns,
            this.constants.actionsList,
            this.location
          );
          this.constants.displayedColumns = actions.displayedColumns;
          this.constants.displayedActions = actions.displayedActions;
          this.loadData();
        }
      });
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  loadData() {
    this.constants.loading = true;
    this.constants.elements = true;
    this.commissionsService
      .getItems()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(
        result => {
          this.commissionsList = [];
          result.data.forEach((element: any) => {
            const elementCommission = element.attributes;
            const elementChannel = element.relationships.channel;
            this.commission = {
              id: element.id,
              idChannel: elementChannel.id,
              channel: elementChannel.name,
              startValue: elementCommission.startValue,
              endValue: elementCommission.endValue,
              fixValue: elementCommission.fixValue,
              variableValue: elementCommission.variableValue
            };
            this.commissionsList.push(this.commission);
          });
          if (this.commissionsList.length) {
            this.dataSource = new MatTableDataSource(this.commissionsList);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.constants.filter = this.dataSource.filteredData;
            this.selection.clear();
          } else {
            this.constants.elements = false;
          }

          this.constants.error = false;
          this.constants.loading = false;
        },
        error => {
          this.constants.errorText = this.generalsService.showError(error);
          this.constants.error = true;
          this.constants.loading = false;
        }
      );
  }

  reload() {
    this.generalsService.reload(this);
  }

  edit(action: string, item?: Commission) {
    let dialog: any;

    const data = {
      action: action,
      item: {},
      relationships: {}
    };

    const loading = this.generalsService.loading();
    this.channelsService
      .getItems()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(
        result => {
          let res = false;
          loading.close();
          if (!result.data || result.data.length <= 0) {
            res = true;
          }

          if (action === this.appConfig.ACTIONS.add.id && res) {
            this.generalsService.notification(
              this.appConfig.NOTIFICATION.error,
              this.appConfig.LANG.commissions.noChannels
            );
          } else {
            if (action === this.appConfig.ACTIONS.add.id) {
              this.constants.message = this.appConfig.LANG.message.addSuccess;
            } else {
              data.item = item;
              this.constants.message = this.appConfig.LANG.message.editSuccess;
            }

            data.relationships = result.data;
            dialog = this.generalsService.modal(CommissionsEditComponent, data);

            dialog
              .afterClosed()
              .pipe(takeUntil(this.constants.destroy$))
              .subscribe((afterClosedResult: any) => {
                this.generalsService.afterClosed(
                  this,
                  afterClosedResult,
                  this.constants.message
                );
              });
          }
        },
        error => {
          loading.close();
          this.generalsService.notification(
            this.appConfig.NOTIFICATION.error,
            this.generalsService.showError(error)
          );
        }
      );
  }

  selectDelete() {
    const numSelected = this.selection.selected.length,
      numRows = this.dataSource.data.length;

    this.constants.labelDelete = this.generalsService.messageSelectedDelete(
      'label',
      numSelected,
      numRows
    );
  }

  filterData(event: any) {
    this.generalsService.applyFilter(this.dataSource, event);
    this.constants.filter = this.dataSource.filteredData;
  }
}
